import {JACKPOT_STATE} from '../const/jackpot_map_ids';

export type BLUE_RIBBON_POT_STATE = "COLD" | "CHILLY" | "WARM" | "HOT";

export type BLUE_RIBBON_INACTIVE_REASONS = 'ACTIVE_TIME' | 'COOL_DOWN' | 'MAX_ITERATIONS_EXCEEDED' | 'GAME_ENDED' | 'FUTURE_GAME';

export enum PartyJackpotType {
    Daily = 0,
    Hourly = 1
};

export enum PartyJackpotJoinStatus {
    Neutral = 0,
    Joined = 1,
    NotJoined = 2
}

export interface IBlueRibbonJackpot {
    readonly jackpotId: string;
    readonly initialValue: number;
    readonly currentValue: number;
    readonly isOptedIn: boolean;
    readonly isActive: boolean;
    readonly hasWin: boolean;
    readonly winAmount: number;
    readonly winISO3Currency: string | null;
    readonly winningPlayer: string | null;
    readonly potState: BLUE_RIBBON_POT_STATE;
    readonly isEligible: boolean;
    readonly hasBetContributions: boolean;

    getStandardJackpotState(): JACKPOT_STATE;
}

export interface IBlueRibbonPartyJackpot extends IBlueRibbonJackpot {
    readonly type: PartyJackpotType;
    readonly inactiveReason: BLUE_RIBBON_INACTIVE_REASONS;
    readonly startHour: string;
    readonly endHour: string;
    readonly mustHitTime: Date;
    readonly B2CLink: string;
    readonly joinStatus: PartyJackpotJoinStatus;
    readonly name: string;
    readonly hasRealMoneyWinPrize: boolean;
    setName(listName: string);
    readonly supportsAllLiveGames: boolean;
    readonly isExpired: boolean;
}

export interface IBlueRibbonPersonalJackpot extends IBlueRibbonJackpot {
}
